import { Navigate } from 'react-router-dom';
import { DASHBOARD_PAGE_PATH } from 'routes/paths';

/**
 * The pages used to redirect the user after login.
 */
export default function WelcomePage() {
  return <Navigate to={DASHBOARD_PAGE_PATH.original} replace={true} />;
}
